<app-dialog-sidebar>
    <div class="reserve-in-store-form">
        <app-reserve-in-store-form (updateEvent)="onUpdateEvent($event)"></app-reserve-in-store-form>
    </div>
</app-dialog-sidebar>
